import { render, staticRenderFns } from "./Colors.vue?vue&type=template&id=31de930f&scoped=true"
import script from "./Colors.vue?vue&type=script&lang=js"
export * from "./Colors.vue?vue&type=script&lang=js"
import style0 from "./Colors.vue?vue&type=style&index=0&id=31de930f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31de930f",
  null
  
)

export default component.exports